module.exports = __webpack_public_path__ + "39c8e30f966da852f2f7f4285702d892.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/rabbit-in-hat-right.png
// module id = 2721
// module chunks = 0